import React from 'react';
import PropTypes from 'prop-types';

import classes from './MotorDataPhaseItem.css';
import Arrow from '../../../UI/Arrow/Arrow';

const motorDataPhaseItem = props => {
  const { selected, phase, voltage } = props;
  return (
    <li className={classes.MotorDataPhaseItem} onClick={selected}>
      <h2>
        <span className={classes.Green}>{phase}</span>
        <span> </span>
        <span className={classes.Orange}>{voltage}</span>
      </h2>
      <Arrow direction="next" />
    </li>
  );
};

motorDataPhaseItem.propTypes = {
  selected: PropTypes.func,
  phase: PropTypes.string.isRequired,
  voltage: PropTypes.string.isRequired
};

export default motorDataPhaseItem;
